module.exports = __webpack_public_path__ + "img/ccf2026.df50e141.png";